import pic from "../../assets/images/placeholder.png";
import { ModalComponentProps } from "../../types";
import InfoItem from "../common/InfoItem";
import CustomModal from "../ui/CustomModal";

export default function ViewFeedbackDetails({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps) {
  return (
    <CustomModal
      title="Feedback Details"
      {...rest}
      handleClose={handleClose}
      width={600}
      footer={null}
    >
      <div className="p-4">
        <InfoItem title="Company Name" children="Elevate Digital Agency" />
        <InfoItem title="Company Email" children="bakerhossain.cse@gmail.com" />
        <InfoItem title="Company No." children="+8801736398503" />
      </div>
      <img src={pic} alt="" className="w-[197px] h-[167px]" />
      <div className="pb-4 px-4">
        <h4 className="text-[#2d3643] text-lg font-medium leading-[30px]">
          Description
        </h4>
        <p className="text-display-body text-base font-normal leading-7 mt-1.5 ">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book.
        </p>
      </div>
    </CustomModal>
  );
}
